import {
  EditIcon,
  IconButtonColorEnum,
  IconButtonSection,
  IconButtonSectionInternalProps,
  IconButtonSectionSizeEnum,
  TextOrientationEnum,
} from '@acceso/design-system';
import { useTranslation } from 'react-i18next';

import { ItemList } from '@/components/ItemList';
import { UserAction } from '@/components/UserAction';
import { ProductionCenterType } from '@/features/production-center/types';

const internalPropsIconButtonEditUser: IconButtonSectionInternalProps = {
  icon: {
    type: EditIcon,
  },
  iconButton: {
    color: IconButtonColorEnum.NONE_DEFAULT,
  },
  text: {
    value: 'Editar',
    orientation: TextOrientationEnum.LEFT,
    className: 'text-text-dark-10 text-body-3 font-regular',
  },
};

type ProductionCenterDetailsProps = {
  productionCenter: ProductionCenterType;
  onUpdate: (productionCenter: ProductionCenterType) => void;
};

export function ProductionCenterDetail({
  productionCenter,
  onUpdate,
}: ProductionCenterDetailsProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 flex-col items-start self-stretch">
      <div className="flex items-start justify-end self-stretch">
        <IconButtonSection
          onClick={() => onUpdate(productionCenter)}
          internalProps={internalPropsIconButtonEditUser}
          size={IconButtonSectionSizeEnum.LG}
        />
      </div>
      <div className="flex w-full flex-col divide-y divide-stroke-20">
        <ItemList title={t('Tipo')}>{productionCenter.production_center_type}</ItemList>
        <ItemList title={t('Grupo')}>{productionCenter.parameters?.group_id}</ItemList>
        <ItemList title={t('Descripción')}>{productionCenter.description}</ItemList>
        <ItemList title={t('Creado por')}>
          <UserAction
            id={productionCenter?.created_by || new Date().toISOString()}
            timestamp={productionCenter?.created_at || new Date().toISOString()}
          />
        </ItemList>
        <ItemList title={t('Actualizado por')}>
          <UserAction
            id={productionCenter?.created_by || new Date().toISOString()}
            timestamp={productionCenter?.created_at || new Date().toISOString()}
          />
        </ItemList>
      </div>
    </div>
  );
}
